
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {
    "buildId": "7910fd00-ad96-4185-be44-717835b3f9bb"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "/builds/sites/wnhub-general-client/app.config.ts"

export default /*@__PURE__*/ defuFn(cfg0, inlineConfig)
